<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <div>
        <!--<div v-if='btns.add'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-add" title="开户" @click='buttonClk("add")'/></div>-->
        <ejs-dropdownbutton :items='addgroup' iconCss='icon hero-icon hero-icon-batch-add' :select='dropDownAddGroup'></ejs-dropdownbutton>
        <!--<div v-if='btns.mod'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-edit" title="修改" @click='buttonClk("mod")'/></div>-->
        <ejs-dropdownbutton :items='modgroup' iconCss='icon hero-icon hero-icon-batch-edit' :select='dropDownModGroup'></ejs-dropdownbutton>
        <div v-if='btns.del'>
          <!--<button class="e-btn e-tbar-btn icon hero-icon hero-icon-remove" :title="$t('SubscriberIms.del')" @click='buttonClk("del")'/>-->
          <button :title='$t("SubscriberIms.del")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("del")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-remove e-icons"></span>
          </button>
        </div>
        <div v-if='btns.refresh'>
          <!--<button class="e-btn e-tbar-btn icon hero-icon hero-icon-refresh" :title="$t('SubscriberIms.fresh')" @click='buttonClk("refresh")'/>-->
          <button :title='$t("SubscriberIms.fresh")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("refresh")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-refresh e-icons"></span>
          </button>
        </div>
        <!--<div v-if='btns.groupMember'>-->
        <ejs-dropdownbutton :items='groupMember' iconCss='icon hero-icon hero-icon-groupmember' :select='dropDownGroupMember'></ejs-dropdownbutton>
        <!--</div>-->
        <div v-if='btns.import'>
          <!--<button class="e-btn e-tbar-btn icon hero-icon hero-icon-excel-import" :title="$t('SubscriberIms.import')" @click='buttonClk("import")'/>-->
          <button :title='$t("SubscriberIms.import")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("import")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-import e-icons"></span>
          </button>
        </div>
        <!--<div v-if='btns.export'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-excel-export" title="导出" @click='buttonClk("export")'/></div>-->
        <div v-if='btns.export'>
          <div v-if='btns.export'>
            <!--<button class="e-btn e-tbar-btn icon hero-icon hero-icon-excel-export" :title="$t('SubscriberIms.export')" @click='buttonClk("export")'/>-->
            <button :title='$t("SubscriberIms.export")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("export")' data-ripple="true" tabindex="-1" style="width: auto;">
              <span class="e-btn-icon icon hero-icon hero-icon-export e-icons"></span>
            </button>
          </div>
          <!--<download-excel :data = "jsoninfo.json_data" :fields = "jsoninfo.json_fields" :fetch="setFetchOper">-->
          <!--<download-excel :fields = "jsoninfo.json_fields" :fetch="setFetchOper" worksheet="group" :name="jsoninfo.fileName">-->
          <!--<div class="btn e-tbar-btn icon hero-icon hero-icon-excel-export" :title="$t('SubscriberIms.export')"></div>-->
          <!--</download-excel>-->
        </div>
        <div class="e-toolbar-item e-separator" aria-disabled="false"></div>
        <div v-if='btns.qry'>
          <!--<button class="e-btn e-tbar-btn icon hero-icon hero-icon-search" :title="$t('SubscriberIms.search')" @click='buttonClk("search")'/>-->
          <button :title='$t("SubscriberIms.search")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("search")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-search e-icons"></span>
          </button>
        </div>
      </div>
    </ejs-toolbar>
  </div>
</template>

<script>
export default {
  name: 'GroupTableMenu',
  data() {
    return {
      exportParam: {},
      jsoninfo: {
        fileName: `group_${new Date().getTime()}`,
        json_fields: {
          '*Group Name:\r\nNo more than 15 characters': 'grpname',
          '*Group Type:\r\n0：Normal Group\r\n1：Roaming Group\r\n2：Hybrid Group\r\n3：Cross-system Group\r\n4：Grading Group': 'grptype',
          '*Group Property:\r\n0：Static Group\r\n1:Dynamic Group': 'grpproperty',
          '*GSI:\r\nSubject to dialing scheme': 'grpnum',
          '*Organization ID': 'vpnid',
          '*Group Priority:\r\n1～255': 'grpproperty',
          '*Floor Queue:\r\n0：False\r\n1：true': 'grpproperty',
        }
      },
      components: {

      },
      btns: {
        add: true,
        mod: true,
        del: true,
        refresh:true,
        groupMember: true,
        qry: true,
        import: true,
        export: true
      },
      groupMember: [
        {
          text: this.$t('SubscriberIms.addUserMember'),
          value: 0
        },
        {
          text: this.$t('SubscriberIms.qryUserMember'),
          value: 1
        }],
      addgroup: [
        {
          text: this.$t('SubscriberIms.addGroup'),
          value: 0
        },
        {
          text: this.$t('SubscriberIms.batchAddGroup'),
          value: 1
        }],
      modgroup: [
        {
          text: this.$t('SubscriberIms.modGroup'),
          value: 0
        },
        {
          text: this.$t('SubscriberIms.batchModGroup'),
          value: 1
        }]
    };
  },
  methods: {
    buttonClk(args) {
      this.$emit('methodEnum', args);
    },
    dropDownGroupMember(it) {
      if (it.item.value === 0) {
        this.$emit('methodEnum', 'addGroupMember');
      } else if (it.item.value === 1) {
        this.$emit('methodEnum', 'qryGroupMember');
      }
    },
    dropDownAddGroup(it) {
      if (it.item.value === 0) {
        this.$emit('methodEnum', 'add');
      } else if (it.item.value === 1) {
        this.$emit('methodEnum', 'batchAdd');
      }
    },
    dropDownModGroup(it) {
      if (it.item.value === 0) {
        this.$emit('methodEnum', 'mod');
      } else if (it.item.value === 1) {
        this.$emit('methodEnum', 'batchMod');
      }
    },
    // async setFetchOper() {
    //   console.log(this.exportParam);
    //   let data = [];
    //   await this.$axios.post('/lte/ems/subscriber/ims/exportData', this.exportParam).then((response) => {
    //     // console.log(response);
    //     if (response.status !== 200) {
    //       this.$layer.alert({ msg: this.$t('SubscriberIms.requestResTip') });
    //     } else {
    //       data = response.data;
    //     }
    //   });
    //   return data;
    // },
    setGrpQryParam(args) {
      this.exportParam = args;
    },
    startDownload() {
      this.$loading.showLoadding();
    },
    finishDownload() {
      this.$loading.hideLoadding();
    }
  }
};
</script>

<style scoped>

</style>
